import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
};
export function CTAButton({
  label,
  note,
  id
}: CTAButtonProps) {
  return <div id={id} className="mx-auto mt-10 w-full max-w-xl text-center" data-id="element-28" data-mp="2fzbqc7v1p005">
      <motion.a href={CHECKOUT_URL} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-[18px] text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(22,163,74,0.75)] transition-colors duration-150 hover:bg-ctaDark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg md:py-5" data-id="element-29" data-mp="2tz31m0u6g2ag">
        <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-30" data-mp="38pabhs64cczj" />
        <span data-id="element-31" data-mp="1996cl2iajzcx">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="199y5u6of1l01" />
      </motion.a>
      {note && <p className="mx-auto mt-3 max-w-md text-[14px] leading-relaxed text-muted" data-id="element-33" data-mp="1i9bfp0ggcbla">{note}</p>}
    </div>;
}